import React, { useEffect, useState } from 'react'
import UserHero from './partials/UserHero'
import ListGroup from './partials/ListGroup'
import { Link, useNavigate } from 'react-router-dom'
import { FaForward } from "react-icons/fa";
import UserAccount from './partials/UserAccount';
import toast from 'react-hot-toast';
import Formvalidators from '../validators/Formvalidators';
export default function UpdateProfile() {
 
  let navigate =useNavigate()
    let [formData, setFormData]=useState({
        name:"",
        email:"",
        phone:"",
        address:""
    })
    let [show, setShow]=useState(false)
    let [errorMessage, setErrorMessage]=useState({
      name:"",email:"", phone:"", address:""
    })

    function getInputData(e){
      let {value, name}=e.target;
      if(name==="name" || name==="email"|| name==="phone"||name==="address"){
        setErrorMessage((old)=>{
          return{
            ...old,
            [name]:Formvalidators(e)
          }
        })

        setFormData((old)=>{
          return{
            ...old,
             [name]:value
          }
        })
        
      }
    }


    async function postData(e) {
      e.preventDefault();
      
      let error = Object.values(errorMessage).find((x) => x !== "");
      
      if (error) {
        setShow(true);
      } else {
        try {
          let response = await fetch(`/api/user/${formData._id}`, {
            method: "PUT",
            headers: {
              "content-type": "application/json" // सही कर दिया spelling
            },
            body: JSON.stringify({ ...formData })
          });
    
          response = await response.json();
          if (response.result === "Done") {
            toast.success("Update Profile Successfully!");
            navigate("/my-account");
          } else {
            navigate("/");
          }
        } catch (err) {
          console.error("Error while updating profile:", err);
          toast.error("Something went wrong!");
        }
      }
    }
    




    useEffect(() => {
        async function getAPIData() {
          try {
            let response = await fetch(`/api/user/${localStorage.getItem("userid")}`,{
                method:"GET",
                headers:{
                    "contant-type":"application/json"
                }
            }); // your backend API
              response = await response.json()
              
              
              if(response.result==="Done"){
                setFormData((old)=>{
                  return{
                    ...old,
                    ...response.data
                  }
                })
              }
             else{
              navigate("/my-account")
             }
            
          } catch (error) {
            console.error('Error fetching profile:', error);
          }
        }
    
        getAPIData();
      }, [formData?.lengh]);
      
  return (
    <>
        <UserHero/>
       <div className="container">
        <div className="container-fluid mt-3">
         <UserAccount/>
            <div className="row">
            <ListGroup/>
               <div className="col-md-8">
               <div className="admin-heading">
                        {
                            localStorage.getItem("login")?(localStorage.getItem("role")==="@u_%&@!==?*&@!"?
                            <h3>USER PROFILE UPDATE <Link to="/my-account"><FaForward  className='float-end mx-2 ' /></Link> </h3>:
                           <h3>ADMIN PROFILE UPDATE <Link to="/my-account"><FaForward  className='float-end mx-2 ' /></Link> </h3>
                        
                        )
                        :""
                        }
                    </div>
                  <form onSubmit={postData  }>
                  <div className="mb-3 mt-3 ">
                     <label for="exampleFormControlInput1"  className="form-label">Name</label>
                     <input type="text" name='name' onChange={getInputData} value={formData.name} className="form-control" id="exampleFormControlInput1" placeholder="Enter Your Email"/>
                   </div>
                   <div className="mb-3">
                     <label for="exampleFormControlInput1" className="form-label">Email Address</label>
                     <input type="email" name='email' onChange={getInputData} value={formData.email}className="form-control" id="exampleFormControlInput1" placeholder="Enter Your Email"/>
                   </div>
                   <div className="mb-3">
                     <label for="exampleFormControlInput1"  className="form-label">Phone Number</label>
                     <input type="number" name='phone' onChange={getInputData} value={formData.phone} className="form-control" id="exampleFormControlInput1" placeholder="Enter Your Phone"/>
                   </div>
                    <div className="mb-3">
                      <label for="exampleFormControlTextarea1"  className="form-label">Address </label>
                      <textarea name='address' onChange={getInputData} value={formData.address} className="form-control" id="exampleFormControlTextarea1" rows="3" placeholder='Address....'></textarea>
                    </div>
                    <div className="admmin-update mb-5">
                        <button className='w-100 btn-primary' type='submit'>UPDATE PROFILE</button>
                    </div>
                  </form> 
               </div>
            </div>
        </div>
       </div>

    </>
  )
}
